import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getMataUji = 'master-mata-uji';
const postMataUjiUrl = 'master-mata-uji';
const putMataUji = 'master-mata-uji/';
const deleteMataUji = 'master-mata-uji/';

class MasterMataUjiService {
    getMataUji(currentPage,pageSize,filter) {
        return axios.get(            
            API_URL + getMataUji + '?pageNo=' + currentPage + '&pageSize='+pageSize+'&filter='+filter,
            {
                headers: authHeader()
            });
    }
    getAllMataUji() {
        return axios.get(            
            API_URL + getMataUji + '?pageNo=0&pageSize=1000&status=1',
            {
                headers: authHeader()
            });
    }

    getAll() {
        return axios.get(
            API_URL + getMataUji,
            {
                headers: authHeader()
            });
    }

    postMataUji(formData) {        
        return axios
        .post(
            API_URL + postMataUjiUrl,
            formData,
            { headers: authHeader() }
        );
    }

    putMataUji(formData) {
        var headers = authHeader(); 

        return axios
        .put(
            API_URL + putMataUji + formData.idMasterMataUji, formData,
            { headers: authHeader() }
        );
    }

    deleteMataUji(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deleteMataUji + formData.idMasterMataUji,
                { headers: authHeader() }
            );
    }

}

export default new MasterMataUjiService();
